



































































































import { Moment } from "moment";
import { Component, Vue } from "vue-property-decorator";
import MagazineApi from "@/api/admin/magazine";

@Component
export default class Magazine extends Vue {
  visible = false;
  confirmLoading = false;
  loading = false;
  pagination: any = {};
  data: any[] = [];
  rewardData: any[] = [];
  totalElement: any = 0;
  search: any = "";
  editMode = false;

  magazine = {
    id: "",
    title: "",
    subTitle: "",
    image: "",
    thumbnail: "",
  };

  content = {
    id: "",
    title: "",
    contents: "",
    rewardId: "",
    advertisement: {},
    event: {},
  };

  advertisement = {
    id: "",
    title: "",
    thumbnail: "",
    expireTime: "",
  };

  event = {
    id: "",
    title: "",
    subTitle: "",
    thumbnail: "",
    expireTime: "",
  };
  //컨텐츠 이미지
  contentsFile: any = [];
  //썸네일 이미지
  thumbnailFile: any = [];
  //이벤트 배너
  eventFile: any = [];
  //광고 배너
  advertisementFile: any = [];

  eventChk = false;
  advertisementChk = false;

  beforeUpload = (file: File) => {
    return false;
  };

  mounted() {
    this.load();
  }

  uploadThumbnail(e: any) {
    let imageFile = e.file;
    this.thumbnailFile = imageFile;
    this.magazine.thumbnail = URL.createObjectURL(e.file);
  }

  uploadContent(e: any) {
    let imageFile = e.file;
    this.contentsFile = imageFile;
    this.magazine.image = URL.createObjectURL(e.file);
  }

  async load() {
    localStorage.removeItem("auth");
    let result: any;
    result = await MagazineApi.list();
    this.data = [...result.data];
    this.pagination.total = result.totalCount;

    // this.totalElement = result.totalElements;
    // const pagination = {...this.pagination}
    // pagination.total = (result.totalPages * 10);
    this.loading = false;
    // this.pagination = pagination;
  }

  //모달 관련 함수
  showModal() {
    this.visible = true;
  }

  handleCancel(e: any) {
    this.visible = false;
  }

  showModifyModal(record: any) {
    return {
      on: {
        click: (event: PointerEvent) => {
          this.magazine = record;
          this.editMode = true;
          this.visible = true;
        },
      },
    };
  }

  async handleOk(e: any) {
    this.confirmLoading = true;

    let frm = new FormData();
    frm.append("id", this.magazine.id);
    frm.append("title", this.magazine.title);
    frm.append("subTitle", this.magazine.subTitle);
    frm.append("thumbnail", this.thumbnailFile);
    frm.append("image", this.contentsFile);

    const result = await MagazineApi.insert(frm);
    this.data.push(result);
    //서버와 통신 부분 구현
    setTimeout(() => {
      this.visible = false;
      this.confirmLoading = false;
    }, 2000);
  }

  columns = [
    {
      title: "제목",
      dataIndex: "title",
      key: "title",
      scopedSlots: { customRender: "customTitle" },
    },
    {
      title: "부제목",
      dataIndex: "subTitle",
      key: "subTitle",
      scopedSlots: { customRender: "contents" },
      // width: 80,
    },
    {
      title: "등록일",
      dataIndex: "createdTime",
      key: "createdTime",
    },
  ];
}
